export default __webpack_public_path__ + "images/4e1204cdade37ee9da192eddc0500cf7-musical_small.webp";